import React, { useState } from "react";
import { Text } from "../../formitems/Index";
import { LeftOutlined } from "@ant-design/icons";
import {
  Airport_Query,
  Insert_Airport,
  Airport_Query_false,
  edit_Airport,
} from "../../../Queries/Manager Query/Airport/Airport";
import { useQuery, useMutation } from "@apollo/client";
import { Switch } from "antd";
import { notification } from "antd";
import { Link } from "react-router-dom";
import { Menu, Dropdown } from "antd";
import { DownOutlined } from "@ant-design/icons";
const Airports = () => {
  const [search, setsearch] = useState("");
  const [add_new_airport, setadd_new_airport] = useState(false);
  const [ICAO, setICAO] = useState("");
  const [country, setCountry] = useState("");
  const [iata, setIata] = useState("");
  const [airport, setairport] = useState("");
  const [toggle, settoggle] = useState(true);
  const [isView, setisView] = useState(false);
  const [isEdit, setisEdit] = useState(false);
  const [currentFormData, setCurrentFormData] = useState({});
  const [InsertAirports, { data: Insert }] = useMutation(Insert_Airport, {
    refetchQueries: [{ query: Airport_Query }, { query: Airport_Query_false }],
  });
  const [EditAirports, { data: Editairports }] = useMutation(edit_Airport, {
    refetchQueries: [{ query: Airport_Query }, { query: Airport_Query_false }],
  });
  const { data: AirportQuery } = useQuery(Airport_Query);
  const { data: airportQueryFalse } = useQuery(Airport_Query_false);
  const add_new = () => {
    setadd_new_airport(true);
  };
  const togle = () => {
    toggle ? settoggle(false) : settoggle(true);
  };
  const editAirport = () => {
    setisEdit(true);
  };
  const View = () => {
    setisView(true);
  };
  const closeForm = () => {
    setadd_new_airport(false);
    setisEdit(false);
    setisView(false);
  };
  const menu = (data) => (
    <Menu>
      <Menu.Item>
        <Link
          onClick={() => {
            setCurrentFormData(data);
            View();
          }}
        >
          View
        </Link>
      </Menu.Item>
      <Menu.Item>
        <Link
          onClick={() => {
            setCurrentFormData(data);
            editAirport();
          }}
        >
          Edit
        </Link>
      </Menu.Item>
    </Menu>
  );
  const menu2 = (data) => (
    <Menu>
      <Menu.Item>
        <Link
          onClick={() => {
            setCurrentFormData(data);
            editAirport();
          }}
        >
          Edit
        </Link>
      </Menu.Item>
      <Menu.Item>
        <Link
          onClick={() => {
            setCurrentFormData(data);
            View();
          }}
        >
          View
        </Link>
      </Menu.Item>
    </Menu>
  );
  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "Successfully Added Airport",
      description: "Successfully Added Airport Thank you.",
    });
  };

  const UpdateNotificationWithIcon = (type) => {
    notification[type]({
      message: "Successfully Update Airport ",
      description: `Successfully Update Airport Fields`,
    });
  };
  const PrintNotificationWithIcon = (type) => {
    notification[type]({
      message: "Successfully Print Airport ",
      description: `Successfully Print Airport Thank you`,
    });
  };
  const handleFormFields = (v, fieldName) => {
    switch (fieldName) {
      case "icao":
        setCurrentFormData({ ...currentFormData, icao: v });
        break;
      case "iata":
        setCurrentFormData({ ...currentFormData, iata: v });
        break;
      case "airport":
        setCurrentFormData({ ...currentFormData, airport: v });
        break;
      case "country":
        setCurrentFormData({ ...currentFormData, country: v });
        break;
      default:
        break;
    }
  };
  return (
    <div className="animate__animated animate__fadeIn">
      {/* Airport table */}
      <div
        className={
          "manager-airport-container " +
          (add_new_airport || isEdit || isView ? "hide-element" : "")
        }
      >
        <div className="category-title">Airports</div>
        <button className="submit-button" onClick={add_new}>
          Add New Airports
        </button>
        <div className="table-body-container">
          <div className="table-body-header">All Airports</div>
          <div className="client-list-divider"></div>
          <div className="table-container">
            <div className="table-header-container">
              {/* <div className="display-record">
                <span>Show</span>
                <select>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                </select>
                <span>records</span>
              </div> */}
              <div className="active-switch">
                <span>Active</span>
                <Switch onClick={togle} defaultChecked />
              </div>
              <div className="search-bar">
                <span>Search</span>
                <input
                  type="text"
                  value={search}
                  onChange={(e) => setsearch(e.target.value)}
                />
              </div>
            </div>
            {toggle === true
              ? AirportQuery?.aatmsv4_airports.map((data, index) => {
                  if (data?.icao.toLowerCase().includes(search.toLowerCase())) {
                    return (
                      <div className="table-row-container" key={index}>
                        <div className="table-row-top">
                          <div className="items">
                            <div className="title">ICAO</div>
                            <div className="value">{data?.icao}</div>
                          </div>
                          <div className="items">
                            <div className="title">IATA</div>
                            <div className="value">{data?.iata}</div>
                          </div>
                          <div className="items">
                            <div className="title">Name</div>

                            <Dropdown overlay={menu(data)}>
                              <a
                                className="ant-dropdown-link"
                                onClick={(e) => e.preventDefault()}
                                id="uploadQualifications-dropdown"
                              >
                                <div className="value">
                                  {data?.airport}
                                  <DownOutlined />
                                </div>
                              </a>
                            </Dropdown>
                          </div>
                          <div className="items">
                            <div className="title">Country</div>
                            <div className="value">{data?.country}</div>
                          </div>
                          <div className="items">
                            <div className="title">Active</div>
                            <div className="value">
                              {data.active === true ? "True" : "False"}
                            </div>
                          </div>
                          {/* <Dropdown overlay={menu(data)}>
                            <a
                              className="ant-dropdown-link"
                              onClick={(e) => e.preventDefault()}
                            >
                              <i className="fa fa-ellipsis-h" />
                              <DownOutlined />
                            </a>
                          </Dropdown> */}
                        </div>
                      </div>
                    );
                  }
                })
              : airportQueryFalse?.aatmsv4_airports.map((data, index) => {
                  if (data?.icao.toLowerCase().includes(search.toLowerCase())) {
                    return (
                      <div className="table-row-container" key={index}>
                        <div className="table-row-top">
                          <div className="items">
                            <div className="title">ICAO</div>
                            <div className="value">{data?.icao}</div>
                          </div>
                          <div className="items">
                            <div className="title">IATA</div>
                            <div className="value">{data?.iata}</div>
                          </div>
                          <div className="items">
                            <div className="title">Name</div>
                            <div className="value">{data?.airport}</div>
                          </div>
                          <div className="items">
                            <div className="title">Country</div>
                            <div className="value">{data?.country}</div>
                          </div>
                          <div className="items">
                            <div className="title">Active</div>
                            <div className="value">
                              {data.active === true ? "True" : "False"}
                            </div>
                          </div>
                          <Dropdown overlay={menu2(data)}>
                            <a
                              className="ant-dropdown-link"
                              onClick={(e) => e.preventDefault()}
                            >
                              <i className="fa fa-ellipsis-h" />
                              <DownOutlined />
                            </a>
                          </Dropdown>
                        </div>
                      </div>
                    );
                  }
                })}
          </div>
        </div>
        {/* <div className="print-email-container">
          <button className="submit-button" style={{ marginTop: "unset" }}>
            <i className="fa fa-download" />
          Download
        </button>
          <button className="print-button">
            <i className="fa fa-print" />
          Print
        </button>
          <button className="email-button">
            <i className="fa fa-envelope" />
          Email
        </button>
        </div> */}
      </div>
      {/* add new airport form */}
      <div className={add_new_airport ? "" : "hide-element"}>
        <div className="category-title">
          <span className="client-back" onClick={() => closeForm()}>
            {<LeftOutlined />} Airport
          </span>
          Add New Airport
        </div>

        <div className="toggle-form-container">
          <Text
            title="ICAO"
            value={ICAO}
            onChange={(e) => setICAO(e.target.value)}
          />
          <Text
            title="IATA"
            value={iata}
            onChange={(e) => setIata(e.target.value)}
          />
          <Text
            title="Name"
            value={airport}
            onChange={(e) => setairport(e.target.value)}
          />
          <Text
            title="Country"
            value={country}
            onChange={(e) => setCountry(e.target.value)}
          />
          <Text title="Active" value="True" disabled />
          <button
            className="submit-button"
            onClick={() => {
              InsertAirports({
                variables: {
                  icao: ICAO,
                  iata: iata,
                  airport: airport,
                  country: country,
                },
              });
              setICAO("");
              setairport("");
              setIata("");
              setCountry("");
              openNotificationWithIcon("success");
              closeForm();
            }}
          >
            Add
          </button>
          <button onClick={() => closeForm()} className="cancel-button">
            Cancel
          </button>
        </div>
      </div>
      {/* Edit Airports */}
      <div className={isEdit ? "" : "hide-element"}>
        <div className="category-title">
          <span className="client-back" onClick={() => closeForm()}>
            {<LeftOutlined />} Airport
          </span>
          Edit Airport
        </div>

        <div className="toggle-form-container">
          <Text
            title="ICAO"
            disabled
            value={currentFormData?.icao}
            onChange={(e) => handleFormFields(e.target.value, "icao")}
          />
          <Text
            title="IATA"
            value={currentFormData?.iata}
            onChange={(e) => handleFormFields(e.target.value, "iata")}
          />
          <Text
            title="Airport Name"
            value={currentFormData?.airport}
            onChange={(e) => handleFormFields(e.target.value, "airport")}
          />
          <Text
            title="Country"
            value={currentFormData?.country}
            onChange={(e) => handleFormFields(e.target.value, "country")}
          />
          <Text title="Active" value="True" disabled />
          <button
            className="submit-button"
            onClick={() => {
              EditAirports({
                variables: {
                  icao: currentFormData?.icao,
                  iata: currentFormData?.iata,
                  airport: currentFormData?.airport,
                  country: currentFormData?.country,
                },
              });
              closeForm();
              UpdateNotificationWithIcon("success");
            }}
          >
            Update Airport
          </button>
          <button onClick={() => closeForm()} className="cancel-button">
            Cancel
          </button>
        </div>
      </div>
      <div className={isView ? "" : "hide-element"}>
        <div className="category-title">
          <span className="client-back" onClick={() => closeForm()}>
            {<LeftOutlined />} Airport
          </span>
          View Airport
        </div>
        <div className="toggle-form-container">
          <Text
            title="ICAO"
            disabled
            value={currentFormData?.icao}
            onChange={(e) => handleFormFields(e.target.value, "icao")}
          />
          <Text
            title="IATA"
            disabled
            value={currentFormData?.iata}
            onChange={(e) => handleFormFields(e.target.value, "iata")}
          />
          <Text
            title="Airport Name"
            disabled
            value={currentFormData?.airport}
            onChange={(e) => handleFormFields(e.target.value, "airport")}
          />
          <Text
            title="Country"
            disabled
            value={currentFormData?.country}
            onChange={(e) => handleFormFields(e.target.value, "country")}
          />
          <Text title="Active" value="True" disabled />
          {/* <button
            className="submit-button"
            onClick={() => {
              closeForm();
              PrintNotificationWithIcon("success");
            }}
          >
            Print Airport
          </button>
          <button onClick={() => closeForm()} className="cancel-button">
            Cancel
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default Airports;
